// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { nullValidation, string } from "@altostra/type-validations/lib/primitives";

export const isPostLandingPagePostLaunchDraftResult = objectOf({
  info: string,
  landing_page_bson_id: string,
  post_launch_draft_id: string,
});

export const isDeleteLandingPagePostLaunchDraftResult = objectOf({
  info: string,
  landing_page_bson_id: string,
  post_launch_draft_id: nullValidation,
});
